import { dateToLabel } from 'further-ui/utils';
import {
  ScrollableRow,
  ScrollableContainer,
} from 'components/TableComponents/TableComponents';
import InvestorAllocationsTable from './InvestorAllocationsTable';
import { useFormContext } from 'react-hook-form';
import { realisation as rules } from 'further-ui/validations';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { Typography } from '@mui/material';
import { Grid } from '@mui/material';
import { groupBy } from 'lodash';
import { AppSimpleSelect, FieldRow } from 'components/FormElements';
import { getInvestorAllocationTypeLabels } from 'further-ui/labels';
import TotalsTable from './TotalsTable';
import { AllocationRule } from 'further-types/lp/allocations';
import useSyncInvestorAllocations from '../../../hooks/useSyncInvestorAllocations';
import { InvestmentAllocation } from '../../../types';

type Props = {
  currency: CurrencyCode;
  considerationIndex: number;
  investmentAllocation: Array<InvestmentAllocation>;
  flatInvestmentAllocations: Array<InvestmentAllocation>;
};
const InvestmentSplitPerInvestorTable: React.FC<Props> = ({
  currency,
  considerationIndex,
  investmentAllocation,
  flatInvestmentAllocations,
}) => {
  const { control, getValues } =
    useFormContext<rules.CreateRealisationFormValues>();

  const { setInvestorAllocationType } = useSyncInvestorAllocations();

  const dropdownValue = investmentAllocation[0].allocationType;

  const assetName = getValues('assetName');
  const perHoldingClass = groupBy(investmentAllocation, 'holdingClassId');

  const allocationTypesOptions = [
    {
      value: AllocationRule.PerOriginalInvestment,
      label: getInvestorAllocationTypeLabels(
        AllocationRule.PerOriginalInvestment,
        assetName,
      ),
    },
    {
      value: AllocationRule.Manual,
      label: getInvestorAllocationTypeLabels(AllocationRule.Manual, assetName),
    },
  ];

  const onDropdownChange = (value: AllocationRule) => {
    setInvestorAllocationType({
      considerationIndex,
      investmentId: investmentAllocation[0].investmentId,
      newAllocationType: value,
    });
  };

  return (
    <>
      <Typography variant="body1">
        {`Investment  on ${dateToLabel(
          investmentAllocation[0].investmentDate,
        )}`}
      </Typography>
      <Grid size={{ sm: 12, md: 12, lg: 8 }}>
        <FieldRow centerTitle title="Allocation rule">
          <AppSimpleSelect
            value={dropdownValue}
            fullWidth
            options={allocationTypesOptions}
            onChange={(e) => onDropdownChange(e.target.value as AllocationRule)}
          />
        </FieldRow>
      </Grid>
      <ScrollableContainer
        key={`${investmentAllocation[0].investmentId}-container`}
      >
        <ScrollableRow key={`${investmentAllocation[0].investmentId}-row`}>
          {Object.values(perHoldingClass).map((holdingClass, index) => (
            <InvestorAllocationsTable
              key={`${holdingClass[0].investmentId}-${holdingClass[0].holdingClassId}-table`}
              currency={currency}
              considerationIndex={considerationIndex}
              investmentAllocation={holdingClass}
              flatInvestmentAllocations={flatInvestmentAllocations}
              control={control}
              isFirstTable={index === 0}
            />
          ))}
          <TotalsTable
            currency={currency}
            investmentAllocation={investmentAllocation}
          />
        </ScrollableRow>
      </ScrollableContainer>
    </>
  );
};

export default InvestmentSplitPerInvestorTable;
